module.exports = __webpack_public_path__ + "Fondo_azul.c553f8f86f634784dcb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Fondo_azul.png
// module id = 381
// module chunks = 8